// import React, { useState, useEffect } from "react";
// import Typewriter from "typewriter-effect";
// import HeroImage from "../assets/heroImage.png";

// function Home() {
//   const [isMounted, setIsMounted] = useState(false);

//   useEffect(() => {
//     setIsMounted(true);
//     return () => setIsMounted(false);
//   }, []);

//   return (
    // <section id="home" className="h-screen flex flex-col justify-center items-center bg-gray-50">
    //   <div className="w-full max-w-screen-md px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center">
    //     <img src={HeroImage} alt="My Photo" className="mx-auto md:mx-0 rounded-full w-40 h-40 md:w-64 md:h-64 object-cover"/>
    //     <div className="flex-1">
    //       <h1 className="text-4xl sm:text-5xl md:text-4xl font-bold mb-4">
    //         Hello, I'm{" "}
    //         {isMounted && (
    //           <Typewriter
    //             options={{
    //               strings: ["Martina Varghese"],
    //               autoStart: true,
    //               loop: true,
    //             }}
    //           />
          // )}
//           </h1>
//           <p className="text-xl sm:text-2xl md:text-3xl mb-6">
//             Only 1 professional photo
//           </p>
//           <p className="text-lg sm:text-xl md:text-2xl">
//             A formal introduction of 2-3 lines
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Home;


// 
import React,{useState,useEffect} from 'react';
import { Link } from 'react-scroll';
import HeroImage from "../assets/heroImage.png";
import Typewriter from "typewriter-effect";
import {BiDownload} from "react-icons/bi";
import FileSaver from "file-saver";

function Home() {
    const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  const downloadResume = () => {
   
    const resumeLink = "/fw20_0370-Martina-Varghese-Resume.pdf";    
    window.open(resumeLink, "_blank");
   
    const resumeFile = "/fw20_0370-Martina-Varghese-Resume.pdf";
   
    FileSaver.saveAs(resumeFile, "fw20_0370-Martina-Varghese-Resume.pdf");
  };
  return (
    <section id="home" className="bg-gradient-to-b from-black via-black to-indigo-900 py-40 md:py-60  ">
      <div className="container mx-auto px-2 ">
        <div className="flex flex-col md:flex-row items-center md:space-x-0">
          <div className="w-full md:w-2/5 flex justify-center ">
            <img  src={HeroImage} alt="Profile" className="mx-auto md:mx-0 rounded-full w-40 h-40 md:w-64 md:h-64 object-cover " style={{border:"0px solid red"}} />
          </div>
          <div className="w-full md:w-1/2 text-center md:text-left">
              <h1 className="text-xs sm:text-xs md:text-5xl font-bold mb-4 text-slate-500">
            Hello, I'm{" "}
            {isMounted && (
              <Typewriter
                options={{
                  strings: ["Martina Varghese","I am a Full Stack Web Developer",
                                 "I love Coding",
                                 ],
                  autoStart: true,
                  loop: true,
                }}
              />
            )}
          </h1>
             <p className="text-gray-400 text-xs sm:text-xs md:text-xl mb-6"> I love to work on web application using technologies both backend and frontend like
            Express ,MongoDb,React, JavaScript, Chakra UI,CSS etc.
               
               </p>
               <div className='flex flex-col md:flex-row items-center md:space-x-6 '>
             <Link to="contact" smooth={true} duration={500} className="bg-indigo-600 hover:bg-indigo-700 text-white text-xs md:text-xl font-medium py-3 px-6 rounded-full inline-block hover:scale-110">
               Contact Me
             </Link>
             
            <button onClick={downloadResume}  className="group w-fit  my-2 flex items-center rounded-full font-medium py-3 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-xs md:text-xl cursor-pointer">
               Resume <span >
                 <BiDownload size={20}  className="ml-3 hidden sm:block" />
              </span>
              </button>
           </div>
           </div>
         </div>
      </div>
   </section>
   );
 }

export default Home;




// import React,{useState} from 'react'
// import Typewriter from "typewriter-effect"
// import HeroImage from "../assets/heroImage.png";
// const Home = () => {
//   const [state]=useState({
//     title:"Hi",
//     titleTwo:"I'm",
//     titleThree:"Martina Varghese",
//     image:HeroImage
//   })
//   return (
//     <div
//     name="home"
//     className="h-screen w-full bg-gradient-to-b from-black via-black to-indigo-900">
//       <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
//         <div className="flex flex-col justify-center h-full">
//         <h2 className="text-1.5xl sm:text-6xl font-bold text-white">
//           <div>{state.title}</div>
//           <div>{state.titleTwo}</div>
//           <div>{state.titleThree}</div>
//         </h2>
//         </div>
       
//         <div className="text-1.5 sm:text-6xl font-bold text-white">
//           <Typewriter
//           options={{
//             autoStart:true,
//             loop:true,
//             delay:40,
//             string:[
//               "I am a Full Stack Web Developer",
//               "I love Coding",
//               "CODE !",
              
//             ]
//           }}/>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Home



// import React from "react";
// import HeroImage from "../assets/heroImage.png";
// import { MdOutlineKeyboardArrowRight } from "react-icons/md";
// import {BiDownload} from "react-icons/bi";
// import { Link } from "react-scroll";

// const Home = () => {
//   return (
//     <div
//       name="home"
//       className="h-screen w-full  bg-gradient-to-t from-blue-500 to-bg-transparent "
//     >
//       <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row" style={{border:"0px solid blue"}}>
//         <div className="flex flex-col justify-center h-full" style={{border:"0px solid red"}}>
//           <h2 className="text-1.5xl sm:text-6xl font-bold text-sky-900">
//             I'm a Full Stack Web Developer
//           </h2>
//           <p className="text-black py-4 max-w-md">
//            I love to work on web application using technologies both backend and frontend like
//             Express ,MongoDb,React, JavaScript, Chakra UI,CSS etc.
//           </p>

//           <div style={{display:"flex" , gap:"20px"}}>
//             <Link
//               to="project"
//               smooth
//               duration={500}
//               className="group text-white w-fit px-2 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-teal-700 to-blue-800 cursor-pointer"
//             >
//               Projects
//               <span className="group-hover:rotate-90 duration-300">
//                 <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
//               </span>
//             </Link>
//             <div>
//             <a href="/Martina_Varghese_Resume.pdf" download className="group text-white w-fit px-2 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-teal-700 to-blue-800 cursor-pointer">
//               Resume <span >
//                 <BiDownload size={20}  className="ml-3" />
//               </span>
//               </a>
//           </div>
//           </div>
         
//         </div>

//         <div>
//           <img
//             src={HeroImage}
//             alt="my profile"
//             className="rounded-3xl mx-auto w-2/3 md:w-fit "
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;